import { useUser } from 'core/UserContext';
import { Navigate } from 'react-router-dom';
import logo from './logo.svg';

function Root() {
  const { data } = useUser()

  if (data) return <Navigate to='/app' replace />

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.tsx</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

export default Root;
